import React from "react";
import PropTypes from "prop-types";
import Header from "components/Header";
import Sidebar from "components/SidebarV2";

const Layout = (props) => {
    const { children } = props;
    return (
        <>
            <Header />
            <div className="d-flex flex-row height-with-header">
                <Sidebar />
                <div className="container-fluid no-pad">{children}</div>
            </div>
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
